/** Reference zoom where {@link SURVEY_WFS_POINT_DEFAULT_BASE_PX} matches on-screen size. */
export const SURVEY_WFS_POINT_REF_ZOOM = 15;

/** Default marker size (px) at {@link SURVEY_WFS_POINT_REF_ZOOM}. */
export const SURVEY_WFS_POINT_DEFAULT_BASE_PX = 10;

export const SURVEY_WFS_POINT_MIN_PX = 6;
export const SURVEY_WFS_POINT_MAX_PX = 56;

/** Growth per zoom level above the reference (screen px). */
const SURVEY_WFS_POINT_ZOOM_SCALE = 1.28;

/**
 * Survey WFS point markers are drawn in screen pixels. Scale them up as the
 * map zooms in so points stay readable against the basemap.
 *
 * @param zoom - ArcGIS MapView zoom
 * @param baseSizePx - Preferred size at {@link SURVEY_WFS_POINT_REF_ZOOM}
 */
export function resolveSurveyWfsPointSizePx(
  zoom: number,
  baseSizePx: number = SURVEY_WFS_POINT_DEFAULT_BASE_PX,
): number {
  const safeBase =
    Number.isFinite(baseSizePx) && baseSizePx > 0
      ? baseSizePx
      : SURVEY_WFS_POINT_DEFAULT_BASE_PX;
  const z = Number.isFinite(zoom) ? zoom : SURVEY_WFS_POINT_REF_ZOOM;
  const factor = SURVEY_WFS_POINT_ZOOM_SCALE ** (z - SURVEY_WFS_POINT_REF_ZOOM);
  const px = safeBase * factor;
  return Math.round(
    Math.min(SURVEY_WFS_POINT_MAX_PX, Math.max(SURVEY_WFS_POINT_MIN_PX, px)),
  );
}

/** Half-step zoom key so we do not rewrite renderers on every fractional tick. */
export function roundSurveyWfsPointZoom(zoom: number): number {
  if (!Number.isFinite(zoom)) {
    return SURVEY_WFS_POINT_REF_ZOOM;
  }
  return Math.round(zoom * 2) / 2;
}
